'use client';

import { useSyncExternalStore } from 'react';

import { isPushSupported } from '@module/mdrt-org/shared/utils/helpers/web-push-subscription';

const subscribeToPermissionChanges = (onChange: () => void) => {
  if (!isPushSupported()) return () => undefined;

  let isActive = true;
  let permissionStatus: PermissionStatus | undefined;

  const track = async () => {
    try {
      permissionStatus = await navigator.permissions?.query({ name: 'notifications' });
    } catch {
      return;
    }

    if (isActive) permissionStatus?.addEventListener('change', onChange);
  };

  track();

  return () => {
    isActive = false;
    permissionStatus?.removeEventListener('change', onChange);
  };
};

const getSnapshot = () => isPushSupported() && Notification.permission === 'denied';

const getServerSnapshot = () => false;

export const useNotificationPermissionDenied = (enabled: boolean) => {
  const isPermissionDenied = useSyncExternalStore(
    subscribeToPermissionChanges,
    getSnapshot,
    getServerSnapshot
  );

  return enabled && isPermissionDenied;
};
